
import { Component, Mixins, Emit, Prop, Watch } from "vue-property-decorator";
import { Directory } from "../../../../../../base/domain/drawing";
import { EditableFormatSummary } from "../../../../../domain/editableFormat";
import { ITreeExpandable } from "../../../../../../base/components/system";
import { ModelEditableMixin } from "../../../../../../base/components/system/mixins";
import { ITreeSource } from "../sources";

@Component({
  components: {
  },
})
export default class FormatTreeSourceSelectableMixin extends Mixins(ModelEditableMixin) {
  isLoaded: boolean = false;
  directories: Directory<number, EditableFormatSummary>[] = [];

  async loadTree(): Promise<void> {
    this.directories = [];
    if (!this.treeSource) {
      console.warn("treeSource is empty!!!");
      return;
    }
    this.isLoaded = false;
    await this.treeSource.getTree()
    .then(d => this.directories = d)
    .catch(e => {
      const entityName = this.treeSource.entityName;
      this.$error(
        entityName + "取得失敗",
        entityName + "を読み込めませんでした。",
        e
      );
    })
    .finally(() => this.isLoaded = true);
  }

  @Prop({ default: 0 })
  loadChunkSize: number;

  @Prop({ default: null })
  treeSource: ITreeSource<number, EditableFormatSummary>;

  @Prop()
  filter: (source: EditableFormatSummary | Directory<number, EditableFormatSummary>) => boolean;

  @Watch("treeSource")
  onTreeSourceUpdated(newValue: ITreeSource<number, EditableFormatSummary>, oldValue: ITreeSource<number, EditableFormatSummary>): void {
    this.loadTree();
  }

  expandSelectorTree(selector: ITreeExpandable): void {
    if (this.isLoaded && selector) {
      selector.expandTree();
    }
  }

  @Emit("treeNodeSelectUpdated")
  treeNodeSelectUpdated(value: boolean): void {}

  @Emit("nodeDoubleClicked")
  nodeDoubleClicked(): void {}
}
